export default __webpack_public_path__ + "2669afd7c6e7b7d64b0de0bbda5b9c87.png";